// extracted by mini-css-extract-plugin
export default {"storyContainer":"OurStory_storyContainer__i9YJJ","expertiseContainer":"OurStory_expertiseContainer__f6HNc","myImg":"OurStory_myImg__hdR-O","textHolder":"OurStory_textHolder__rN3Hu"};